import { gql } from '@apollo/client';

export const ZONE_BY_SCAN_CODE = gql`
  query zoneByScanCode($companyId: ID!, $code: String!, $locationId: ID) {
    zoneByScanCode(companyId: $companyId, code: $code, locationId: $locationId) {
      code
      matchedOn
      zone {
        id
        name
        zoneType
        description
        area
        rack
        shelf
        bin
        pickSequence
      }
      matches {
        id
        name
        zoneType
        description
        area
        rack
        shelf
        bin
        pickSequence
      }
    }
  }
`;

export type ScannedZone = {
  id: string;
  name: string;
  zoneType?: string;
  description?: string;
  area?: string | null;
  rack?: string | null;
  shelf?: string | null;
  bin?: string | null;
  /** Position on the location's pick walk; null/undefined when not on the path. */
  pickSequence?: number | null;
};
